import IntroCommunication from '~/pages/communication/intro/libs/components/IntroCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const IntroCommunicationPage = ({ nextPagePath, pageId }: TPageProps) => (
  <IntroCommunication nextPagePath={nextPagePath} pageId={pageId} />
)

export default IntroCommunicationPage
